import * as basic from '../../../config/basic'

export const ai = {
  banner: {
    aiLogo: 'https://static001.geekbang.org/resource/image/06/3a/0655a77bacee1e68d3af8a7426748f3a.png',
    mobileAiLogo: 'https://static001.geekbang.org/resource/image/2b/62/2bd65151f8e02a25d34200aec0a47862.png',
    titleCh: '人工智能赛道',
    titleEn: 'Artificial intelligence',
    qrLeft: 'https://static001.geekbang.org/resource/image/d2/af/d256ae44beca3a2bf8e09cec1b5a4aaf.png',
    qrRight: 'https://static001.geekbang.org/resource/image/d8/77/d820eb22fd4c9203d3c9cc8ea3391677.png',
    mobileQrLeft: 'https://static001.geekbang.org/resource/image/e3/95/e3e35fcc0f46d6ed1fbc85ed1ac20695.png',
    mobileQrRight: 'https://static001.geekbang.org/resource/image/9c/da/9c642c153573a97149dde1e0e4ceecda.png',
    caption: '微信公众号：FATE 开源社区',
    joinGroup: '加入 FATE 联邦学习技术交流群',
    platform: [
      {
        title: 'FedAI 官方中文版',
        mobileTitle: 'FedAI 中文版',
        link: 'https://cn.fedai.org/'
      },
      {
        title: 'FedAI 官方英文版',
        mobileTitle: 'FedAI 英文版',
        link: 'https://www.fedai.org/'
      },
      {
        title: 'GitHub',
        mobileTitle: 'GitHub',
        link: 'https://github.com/FederatedAI/FATE'
      }
    ]
  },
  tutorial: {
    buttonList: [
      {
        id: 1,
        text: '开发教程',
        link: 'https://fate.readthedocs.io/en/latest/zh/'
      },
      {
        id: 2,
        text: '技术文档',
        link: 'https://github.com/FederatedAI/FATE/tree/master/examples'
      }
    ],
    case: [
      {
        logo: 'https://static001.geekbang.org/resource/image/e7/65/e797058b7b5f04759c61e30cf2f9d765.png',
        text: '算法文档',
        link: 'https://fate.readthedocs.io/en/latest/zh/federatedml_component/'
      },
      {
        logo: 'https://static001.geekbang.org/resource/image/ab/65/ab74c9f01189d172525e5c7b889f2c65.png',
        text: '案例集',
        link: 'https://fate.readthedocs.io/en/latest/zh/tutorial/'
      }
    ]
  },
  train: {
    titleCh: '培训视频',
    titleEn: 'INIRODUCE',
    content: [
      {
        title: '《联邦学习技术介绍、应用和 FATE 开源框架》系列课程',
        list: [
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/fa/a6/fa4c643243710bce9a763fba61abbca6.png',
            title: '第1课：联邦学习技术介绍、应用和 FATE 开源框架',
            text: 'FATE 是全球首个工业级的联邦学习开源框架，旨在提供安全的计算框架来支持联邦 AI 生态，其在实践生产中有着丰富的应用。在于 VMware 及机器之心合作的直播课程第一期中，我们将将介绍联邦学习算法的概念、应用、以及 FATE 开源框架介绍和进展。',
            link: 'https://www.bilibili.com/video/BV1JE411p72s'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/66/13/66b22268bfff20c4d95ef0bb2f83ee13.png',
            title: '第2课：快速部署 FATE 开发环境',
            text: '本节课，我们 FATE 的好基友—— VMware 的工程师闪亮登场，从运维的角度来审视 FATE 的各服务，简单为大家介绍部署出现问题时如何定位以及调错。',
            link: 'https://www.bilibili.com/video/BV1ZE41157CV'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/f1/e1/f18604020bf6702b848e99f4e4a7bfe1.png',
            title: '第3课：联邦学习 FATE 算法模块梳理及建模演示',
            text: '在这节课中，我们将梳理目前算法模块中已经实现的算法，包括交集，联邦特征工程组件，联邦广义线性模型和 secureboost 等。',
            link: 'https://www.bilibili.com/video/BV1M7411R7b5'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/ee/e6/eeb851cyybfcdb12a9711a6f11e478e6.png',
            title: '第4课：基于 Kubernetes 构建 FATE 联邦学习环境',
            text: 'Kubernetes 是目前最流行的机器学习调度平台，是我们联合 VMware 团队推出的FATE部署工具，可以通过一行命令在 Kubernetes 上从0部署一个生产级别的 FATE 集群，支持按模块部署，多 FATE 集群管理，实现重启、删除、升级等功能。',
            link: 'https://www.bilibili.com/video/BV1tE411A7cm'
          }
        ],
      },
      {
        title: '圆桌会',
        list: [
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/55/yy/55b295c7d62c6a3a76c7619f2b7103yy.jpg',
            title: '第14期圆桌会：FATE v1.7版本内容介绍',
            text: 'FATE 1.7版本对 FATE 进行了全面升级。架构上，拆分了FATE-Flow 仓库，支持跨系统互联互通和多版本的 FATE；算法功能上，新增了联邦多分类特征工程、联邦学习两方算法等算法新组件，以及支持横向模型通用引擎 serving 等；性能上，横纵向 SecureBoost、PSI 算法等性能大幅提升。',
            link: 'https://www.bilibili.com/video/BV1Br4y117Ss?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/5a/b4/5a2d65d577ca102fcaacd833a41cf3b4.jpg',
            title: '第13期圆桌会：FATE 的在线组件 FATE-Serving2.1.0 版本介绍',
            text: '对FATE的在线组件 FATE-Serving 2.1.0 版本新功能介绍，各组件技术细节做了详细的介绍分享。',
            link: 'https://www.bilibili.com/video/BV1sQ4y1k7w8?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/16/7e/16ce65fe9c422ba275e5d5fc3ec84d7e.jpg',
            title: '第12期圆桌会：FATE 1.6.1 版本更新内容分享',
            text: '讲解最新发布的 FATE1.6.1 版本的更新内容，以及在1.6.1版本中，FATE支持微众自研大数据平台套件 WeDataSphere，本次会议将介绍 FATE on WeDataSphere 在计算、存储、数据管理等模块的实现及其使用场景。',
            link: 'https://www.bilibili.com/video/BV1P44y187wx?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/d8/98/d8fa81da17df4313c86e6b401b8ef198.jpg',
            title: '第11期圆桌会：KubeFATE 新版本高级功能介绍及演示',
            text: '主要介绍 KubeFATE 新版近期增加的一些功能：包括对 FATE 集群的日志收集；查看部署 FATE 的过程任务与子任务状态；支持 FATE-Exchange 部署，Spark 和 eggroll 都可以接入相应的 exchange 集群；支持 FATE 版本v1.6.0；支持 FATE-Serving 版本v2.0.4，同时支持 serving-admin 组件的部署等。',
            link: 'https://www.bilibili.com/video/BV1Kb4y1C7rc?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          }
        ],
      },
      {
        title: '大咖实战分享',
        list: [
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/10/b1/10e11411c45680144989bbb99545d0b1.jpg',
            title: 'FATE LIGHT UP 第四期：FATE 开源项目在联通数科的隐私计算实战应用',
            text: '摘要：2022年7月20日，由 FATE 开源社区发起的系列线上公开课—— FATE 「LIGHT UP」计划第四期邀请通信领域专家，联通数字科技有限公司技术总监樊利安就数据可信在通信领域的价值以及区块链如何与联邦学习开展深度融合等内容进行分享，探讨隐私计算在通信行业的落地及价值。',
            link: 'https://www.bilibili.com/video/BV1BY4y1j7jh?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/80/5c/80270ed4f915ff2cd40bab456c6aa15c.jpg',
            title: 'FATE LIGHT UP 第三期：基于 FATE 的可验证秘密分享算法详解及金控应用场景介绍',
            text: '摘要：2022年6月24日，由 FATE 开源社区发起的系列线上公开课——FATE 「LIGHT UP」计划第三期，邀请到两位 FATE 社区核心贡献者-光大科技有限公司数据工程师李钰和樊昕晔，为大家详细介绍基于 FATE 的可验证秘密分享算法及其相应的金控应用场景。',
            link: 'https://www.bilibili.com/video/BV1LW4y1y7Yh?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/7d/49/7dfa6e56d0ce06d7c20f843200b7da49.jpg',
            title: '【大咖实战分享】第六期：联邦学习落地金控集团的挑战与思考',
            text: '分享摘要：该议题结合了联邦学习落地“临门一脚”的问题，以及业务上的一些思考和技术方案进行了论述。主要内容包括在现有监管背景态势下解决业务问题的技术手段，同时对参与推动共享的组织如何带来效益，给业务人员以激励进行了探讨，最后是在技术的“最后一公里”的问题方面，对联邦学习内核以及难点的问题进行了思考。',
            link: 'https://www.bilibili.com/video/BV1FY41147U1?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/71/17/71ee4413ebb7786b2a8654d4dd36f017.jpg',
            title: '【大咖实战分享】第四期：金融风控行业的联邦建模案例分享',
            text: '分享摘要：1、基于 FATE 进行联邦建模过程中相关经验，以及联邦建模与本地建模的效果对比；2、FATE 运行过程介绍，以及生产中部署架构；3、基于 openresty 进行多方之间的动态路由；4、在线推理：模型管理与推理服务分离。',
            link: 'https://www.bilibili.com/video/BV1vM4y1K7JT?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          }
        ],
      },
      {
        title: '杨强教授分享',
        list: [
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/1c/00/1c3337482c1df62d791732f9eb33b600.jpg',
            title: '【2022年机器之心 AI 科技年会】杨强教授：可信联邦学习',
            text: '加拿大工程院及加拿大皇家科学院两院院士、微众银行首席人工智能官、FATE 开源社区技术指导委员会主席杨强教授受邀出席活动，并在会上系统回顾联邦学习的进展和挑战，提出了可信联邦学习的发展方向，并表示可信联邦学习具备安全可证明、性能可使用、效率可控、决策可解释、模型可监管、普惠等特征。',
            link: 'https://www.bilibili.com/video/BV1334y147HP?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/80/1d/803e7301b2ceee013b1dea1bdd8ab41d.jpg',
            title: '杨强教授受邀出席「2021智能云边开源峰会」，并作“数据要素与联邦学习”主题演讲',
            text: '「2021智能云边开源峰会」正式上线，微众银行首席人工智能官杨强教授受邀出席本次会议，作“数据要素与联邦学习”主题演讲。',
            link: 'https://www.bilibili.com/video/BV1oR4y1H7e7?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/a2/93/a2196d8a3fb65720447fc46151e8fe93.jpg',
            title: '杨强教授：An Introduction to Federated Learning （2021）',
            text: '微众银行首席人工智能官，香港科技大学计算机与工程系讲座教授和前系主任，AAAI-2021 大会主席，国际人工智能联合会(IJCAI)理事会前主席，香港人工智能与机器人学会(HKSAIR)理事长，智能投研技术联盟(ITL)主席，ACM TIST 和IEEE TRANS on BIG DATA创始主编，CAAI，AAAI，ACM，IEEE，AAAS等多个国际学会 Fellow。领衔全球迁移学习和联邦学习研究及应用，著作包括《迁移学习》，《联邦学习》等。',
            link: 'https://www.bilibili.com/video/BV1P44y167rg?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          },
          {
            imgUrl: 'https://static001.geekbang.org/resource/image/62/62/62903dac9ba9d12549363dc5a2f2ec62.jpg',
            title: '第三届世界人工智能大会(WAIC)2020云端峰会——WAIC 数据智能论坛 杨强分享',
            text: '在「WAIC 数据智能论坛」中，杨强教授同与会嘉宾探讨如何化解人工智能面临的风险挑战，提出 AI 的新三定律：AI 需要保护人的隐私，AI 需要保护模型的安全，AI 需要人类伙伴的理解。”由此，联邦学习这一解决世界级数据应用难题的新技术应运而生。',
            link: 'https://www.bilibili.com/video/BV1tt4y1Q7Zo?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
          }
        ],
      },
      {
        title: '活动视频'
      }
    ],
    list: [
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/44/7e/440c6230156b23feed8d309a7147427e.jpg',
        contentText: 'FATE LIGHT UP 第五期：AI 模型知识产权保护的技术突破与法律挑战',
        video: 'https://www.bilibili.com/video/BV1SW4y1a7sB?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/75/74/7565418c12fcc2d53ce0614325fb7974.jpg',
        contentText: 'FL-IJCAI 22 首届可信联邦学习国际线上研讨会',
        video: 'https://www.bilibili.com/video/BV13F411w7gc?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/cc/d0/ccfdec5a0f9517dc659965a99ca164d0.jpg',
        contentText: '5月25日联邦学习安全效率与开源生态论坛',
        video: 'https://www.bilibili.com/video/BV1k34y1j78W?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/f7/81/f75c1fb765816066de6164088e640681.jpg',
        contentText: 'FATE 助力隐私计算落地与应用-范涛老师「0427隐私计算应用与发展线上论坛」',
        video: 'https://www.bilibili.com/video/BV16B4y1m7qD?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/64/65/64e8c7ea954e7b2e6f5d2138e7165b65.jpg',
        contentText: '英特尔 AI 实践日系列第52期-《联邦学习算力挑战与硬件加速》（FATE 开源社区-张骏雪博士）',
        video: 'https://www.bilibili.com/video/BV1na411876k?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/09/b6/09977bb85b1095b388ff64baa98a87b6.jpg',
        contentText: '【隐私计算与联邦学习专场 AI MEETUP】高性能联邦学习算法优化实践',
        video: 'https://www.bilibili.com/video/BV1tq4y1Z7ca?share_source=copy_web&vd_source=6fecab86819e2574c25f67092b64d5cb'
      }
    ],
    buttonText: '查看更多开发教程',
    buttonLink: 'https://fate.readthedocs.io/en/latest/zh/'
  },
  news: {
    titleCh: '新闻资讯',
    titleEn: 'INIRODUCE',
    content: {
      list: [
        {
          id: '01',
          idLogo: basic.one,
          idLogoMobile: basic.oneMobile,
          text: 'FATE 开源社区公布首批成员单位，共建数据价值流通良性生态',
          link: 'https://mp.weixin.qq.com/s/XrrvUQneUC6KXIfjLMud_w'
        },
        {
          id: '02',
          idLogo: basic.two,
          idLogoMobile: basic.twoMobile,
          text: '专家对话 | 联邦学习生态系统愿景与发展路径',
          link: 'https://mp.weixin.qq.com/s/ajonizI8j3qEwGAfJmqDEA'
        },
        {
          id: '03',
          idLogo: basic.three,
          idLogoMobile: basic.threeMobile,
          text: '中国经营报：金控集团数据治理攻坚 隐私计算破壁价值共享',
          link: 'https://mp.weixin.qq.com/s/N1LlaKbB-KWOS7Y5qeQVRQ'
        },
        {
          id: '04',
          idLogo: basic.four,
          idLogoMobile: basic.fourMobile,
          text: '《2022中国开源发展蓝皮书》发布，提及隐私计算开源是数据要素可信流通的关键技术模式',
          link: 'https://mp.weixin.qq.com/s/Rp4E1zM3xh1mwS-HZLieaw'
        },
        {
          id: '05',
          idLogo: basic.five,
          idLogoMobile: basic.fiveMobile,
          text: '“可信联邦学习”将成为隐私计算下一阶段发展重点',
          link: 'https://mp.weixin.qq.com/s/V_TOaQPvrTzDahg_fHwyEg'
        },
        {
          id: '06',
          idLogo: basic.sex,
          idLogoMobile: basic.sexMobile,
          text: '隐私计算仍处于应用初期，开源生态构建或为规模化落地关键',
          link: 'https://mp.weixin.qq.com/s/_ydAxvqRBtVpn44Og0vvTA'
        },
        {
          id: '07',
          idLogo: basic.seven,
          idLogoMobile: basic.sevenMobile,
          text: '可信联邦学习进化：FATE 开启新征程',
          link: 'https://mp.weixin.qq.com/s/zYqWglptQgXkAeMt76vCpg'
        },
        {
          id: '08',
          idLogo: basic.eight,
          idLogoMobile: basic.eightMobile,
          text: '经济日报：隐私计算发展呼唤互联互通',
          link: 'https://mp.weixin.qq.com/s/sZpPoVd5_W9utadKMMxlfA'
        },
        {
          id: '09',
          idLogo: basic.nine,
          idLogoMobile: basic.nineMobile,
          text: '经济观察网 | 杨强院士：隐私计算为何要开源？',
          link: 'https://mp.weixin.qq.com/s/hP_dDLy5N1yzOrW_pc-yrg'
        },
        {
          id: '10',
          idLogo: basic.ten,
          idLogoMobile: basic.tenMobile,
          text: ' 36氪专访｜港科大教授杨强：数据安全时代，可信联邦学习正在改变人工智能的发展逻辑',
          link: 'https://mp.weixin.qq.com/s/DdcUqJT8QO94aVszr-5LLQ'
        }
      ],
      moreLabel: '查看更多开发教程',
      moreLink: 'https://www.infoq.cn'
    }
  },
  books: {
    titleCh: '书籍',
    titleEn: 'INIRODUCE',
    content: [
      {
        bookImg: 'https://static001.geekbang.org/resource/image/da/2d/dab45fddb432d4db0a6403b041c2f62d.png',
        title: '《联邦学习》',
        text: '《联邦学习》一书主要从技术维度出发，重点研究了联邦学习对 AI 的隐私保护和数据安全问题。从广度上看，此书除了讨论了四种联邦学习的基本类型，还讨论了相关的联邦学习激励机制和分布式机器学习。从深度上而言，书中包括原理、算法、平台和应用实例。',
        link: 'https://item.m.jd.com/product/12649191.html?&utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&utm_user=plusmember&gx=RnFnl2UKbTWPztRN8NoiFGQ22A'
      },
      {
        bookImg: 'https://static001.geekbang.org/resource/image/8e/f2/8e90af4eda84d0b8728703821e8963f2.png',
        title: '《迁移学习》',
        text: '近年来，人工智能进入了一个飞速发展的阶段，并且已经上升到国家战略层面。然而现有的技术仍然需要大量的数据作为训练基础，不仅代价高昂，有时也很难获得。因此，如何让机器获取像人一样的推理能力以及小样本下的学习问题，成为了重要的探索方向。迁移学习——将在已知领域中学到的知识和经验迁移到不同但相关的未知领域中来解决新问题——正是人工智能解决小样本学习等问题的重要手段。',
        link: 'https://item.m.jd.com/product/12930984.html?&utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&utm_user=plusmember&gx=RnFnl2UKbTWPztRN8NoiFGQ22A'
      },
      {
        bookImg: 'https://static001.geekbang.org/resource/image/9d/3b/9d75a4aa50d0bee6b4735f17211c163b.png',
        title: '《联邦学习实战》',
        text: '近年来，联邦学习飞速发展，成为解决数据孤岛和用户隐私问题的首选方案。如何应用联邦学习进行实战，也成了大家普遍关心的问题。为了帮助大家更好地将联邦学习应用在实际项目中，杨强教授再次带领团队撰写了国内首本联邦学习实战的权威著作——《联邦学习实战（全彩）》。内容特色鲜明，深度剖析前沿应用案例，侧重于工程实践；配有丰富的视频资源、线上资源；部分案例配以Python代码讲解。',
        link: 'https://item.m.jd.com/product/13206070.html?&utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&utm_user=plusmember&gx=RnFnl2UKbTWPztRN8NoiFGQ22A'
      },
      {
        bookImg: 'https://static001.geekbang.org/resource/image/b3/bd/b3a44c8442629d038152cf400f661fbd.png',
        title: '《可解释人工智能导论》',
        text: 'AI领域全新著作《可解释人工智能导论》重磅发布，该著作汇集人工智能领域12位名家，系统阐述了可解释 AI 研究的问题和方法，详尽展示其广泛应用和积极作用，全面介绍了可解释人工智能的基础知识、理论方法和行业应用。',
        link: 'https://item.m.jd.com/product/13700578.html?&utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&utm_user=plusmember&gx=RnFnl2UKbTWPztRN8NoiFGQ22A'
      },
      {
        bookImg: 'https://static001.geekbang.org/resource/image/e9/2e/e9c53355047b186d9eaa5d9c885e732e.png',
        title: '《隐私计算》',
        text: '由香港科技大学计算机科学与工程系副教授、智能网络与系统实验室主任陈凯教授，加拿大工程院及加拿大皇家科学院两院院士、微众银行首席人工智能官、FATE 开源社区技术指导委员会主席杨强教授联袂撰写的全球首部全面、系统论述隐私计算的中文著作《隐私计算》正式出版发布。',
        link: 'https://item.m.jd.com/product/13604520.html?&utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&utm_user=plusmember&gx=RnFnl2UKbTWPztRN8NoiFGQ22A'
      }
    ]
  }
}
